// extracted by mini-css-extract-plugin
export default {"container":"ModalQR_container__o0rGq","img__container":"ModalQR_img__container__maEJZ","clone__qrcode":"ModalQR_clone__qrcode__3nXfM","form__footer":"ModalQR_form__footer__ggFiK"};